import { Listbox } from '@headlessui/react';
import { ChevronDownIcon, CheckIcon } from '@heroicons/react/24/outline';

export type SignupSelectOption = {
  value: string;
  label: string;
};

type SignupSelectProps = {
  options: SignupSelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  'aria-label'?: string;
};

export default function SignupSelect({
  options,
  value,
  onChange,
  placeholder,
  'aria-label': ariaLabel,
}: SignupSelectProps) {
  const selected = options.find(option => option.value === value) ?? null;

  return (
    <Listbox value={value || null} onChange={next => onChange(next ?? '')}>
      <div className="relative">
        <Listbox.Button
          className="signup-form-input relative cursor-pointer pr-8 text-left"
          aria-label={ariaLabel}
        >
          <span className={`block truncate${selected ? '' : ' signup-form-input--placeholder'}`}>
            {selected?.label ?? placeholder}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-4 w-4 text-gray-500" aria-hidden="true" />
          </span>
        </Listbox.Button>

        <Listbox.Options className="absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-xl border border-gray-300 bg-white py-1 text-sm shadow-lg focus:outline-none">
          {options.map(option => (
            <Listbox.Option
              key={option.value}
              value={option.value}
              className={({ active }) =>
                `relative cursor-default select-none py-2 pl-8 pr-3 text-sm ${
                  active ? 'bg-pink-50 text-blue-900' : 'text-blue-900'
                }`
              }
            >
              {({ selected: isSelected }) => (
                <>
                  <span className={`block truncate ${isSelected ? 'font-medium' : 'font-normal'}`}>
                    {option.label}
                  </span>
                  {isSelected ? (
                    <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-pink-600">
                      <CheckIcon className="h-4 w-4" aria-hidden="true" />
                    </span>
                  ) : null}
                </>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
}
